import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { EditSalaryFooterProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { PageFooter, useNavigationHistory } from "components/common";
//#endregion
import { TranslationKeys } from "translations";
import { ActionButton } from "models/propTypes/commonPropTypes";

const EditSalaryFooter: React.FC<EditSalaryFooterProps> = (props) => {
  const { onSaveClick, isDirty } = props;

  const { goBack } = useNavigationHistory();

  const cancelButton: ActionButton = {
    text: TranslationKeys.Common.Cancel,
    onClick: async () => goBack(),
    secondary: true,
  };

  const saveButton: ActionButton = {
    text: TranslationKeys.Common.Save,
    type: StyleEnums.DisplayType.Success,
    onClick: onSaveClick,
    successMessage: TranslationKeys.Settings.SavedSettingsSuccessfully,
    onActionSuccess: () => goBack(),
  };

  return <PageFooter actions={(isDirty ? [saveButton] : []).concat([cancelButton])} />;
};

export default EditSalaryFooter;
